import { BOT_DATA_NAME } from '../const';

export function createBotTarget() {
  const botTarget = document.createElement('div');
  botTarget.setAttribute('data-name', BOT_DATA_NAME);
  botTarget.style.position = 'absolute';
  botTarget.style.width = '1px';
  botTarget.style.height = '1px';

  // Position it off screen to avoid overflowing the body and causing scrolling issues
  botTarget.style.top = '-9999px';
  botTarget.style.left = '-9999px';

  return botTarget;
}
